export default function PilaresSection() {
  const pilares = [
    {
      number: '01',
      title: 'Autoliderança e Identidade',
      topics: [
        'Autoconhecimento profundo',
        'Gestão emocional',
        'Construção de identidade de liderança',
        'Desenvolvimento de disciplina'
      ]
    },
    {
      number: '02',
      title: 'Propósito e Gestão',
      topics: [
        'Descoberta de propósito',
        'Alinhamento carreira e propósito',
        'Gestão estratégica do tempo',
        'Mentalidade de crescimento'
      ]
    },
    {
      number: '03',
      title: 'Comunicação e Influência',
      topics: [
        'Comunicação assertiva',
        'Storytelling impactante',
        'Posicionamento estratégico',
        'Networking de alto nível'
      ]
    },
    {
      number: '04',
      title: 'Liderança e Legado',
      topics: [
        'Liderança de equipes',
        'Desenvolvimento de pessoas',
        'Maturidade emocional',
        'Construção de legado'
      ]
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4 lg:sticky lg:top-32 lg:self-start">
            <div className="mb-8">
              <h2 className="font-display text-6xl font-bold text-purple-900 mb-6">
                Visão Geral
              </h2>
              <p className="text-2xl text-gray-700 leading-relaxed">
                <strong>Desenvolvimento pessoal</strong>, liderança aplicada e prosperidade
              </p>
            </div>
            <div className="text-purple-200 font-display text-9xl font-bold opacity-20 select-none">
              4<br/>PILARES
            </div>
          </div>

          <div className="lg:col-span-8 space-y-8">
            {pilares.map((pilar, index) => (
              <div
                key={index}
                className="bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100"
              >
                <div className="bg-gradient-to-r from-[#8E217E] to-[#C75AAF] h-20"></div>
                <div className="p-10">
                  <div className="flex items-start space-x-6">
                    <span className="font-display text-8xl font-bold text-gold-500 leading-none">
                      {pilar.number}
                    </span>
                    <div className="flex-1 pt-2">
                      <h3 className="font-display text-3xl font-bold text-purple-900 mb-6">
                        {pilar.title}
                      </h3>
                      <ul className="space-y-3">
                        {pilar.topics.map((topic, idx) => (
                          <li key={idx} className="flex items-start space-x-3">
                            <div className="w-2 h-2 bg-gold-500 rounded-full mt-2 flex-shrink-0"></div>
                            <span className="text-gray-700 text-lg">{topic}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
